import { useEffect, useRef } from "react";

const FAVICON_SIZE = 32;
const DOT_RADIUS = 6;
const DOT_PADDING = 1;

export function useFaviconBadge(hasNotification: boolean) {
  const originalHref = useRef<string | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) return;

    // cache original favicon on first run
    if (originalHref.current === null) {
      originalHref.current = link.href;
    }

    if (!hasNotification) {
      if (originalHref.current) link.href = originalHref.current;
      return;
    }

    // reuse a single off-screen canvas
    if (!canvasRef.current) {
      canvasRef.current = document.createElement("canvas");
      canvasRef.current.width = FAVICON_SIZE;
      canvasRef.current.height = FAVICON_SIZE;
    }

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      ctx.clearRect(0, 0, FAVICON_SIZE, FAVICON_SIZE);
      ctx.drawImage(img, 0, 0, FAVICON_SIZE, FAVICON_SIZE);

      // red dot in top-right corner
      const cx = FAVICON_SIZE - DOT_RADIUS - DOT_PADDING;
      const cy = DOT_RADIUS + DOT_PADDING;

      ctx.beginPath();
      ctx.arc(cx, cy, DOT_RADIUS, 0, 2 * Math.PI);
      ctx.fillStyle = "#ef4444";
      ctx.fill();

      link.href = canvas.toDataURL("image/png");
    };
    img.src = originalHref.current!;

    return () => {
      // restore on cleanup so hot-reload doesn't leave stale favicons
      if (originalHref.current && link) link.href = originalHref.current;
    };
  }, [hasNotification]);
}
